import { AspectRatio, FlexBox, Icon, StandardTile, StandardTileName, tokensRaw } from '@vp/swan';
import styled from 'styled-components';
import { __ } from '@99designs/i18n';
import { NavigationTracking, sendNavigationEvent } from '@99designs/tracking';

interface SeeAllTileProps {
    href: string;
    trackingData?: NavigationTracking;
}

const StyledTile = styled(StandardTile)`
    height: 100%;
    padding-bottom: 0 !important;
`;

const StyledTileContent = styled(FlexBox)`
    height: 100%;
    gap: ${tokensRaw.SwanSemSpace6};

    @media (max-width: ${tokensRaw.SwanBaseBreakpointSmEnd}) {
        gap: ${tokensRaw.SwanSemSpace5};
    }
`;

const IconWrapper = styled.div`
    border-radius: 50%;
    background-color: ${tokensRaw.SwanBaseColorWhite};
    padding: ${tokensRaw.SwanSemSpace4};
`;

export function SeeAllTile({ href, trackingData }: SeeAllTileProps) {
    return (
        <AspectRatio ratio={3 / 4}>
            <StyledTile
                bgc="warm-white"
                skin="standard"
                render={({ className, children }) => (
                    <a
                        href={href}
                        onClick={() => {
                            if (trackingData) {
                                sendNavigationEvent(trackingData);
                            }
                        }}
                        data-section={trackingData?.label}
                        data-translation={trackingData?.navigationDetail}
                        data-testid="see-all-tile"
                        className={className}
                    >
                        {children}
                    </a>
                )}
            >
                <StyledTileContent
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <IconWrapper>
                        <Icon iconType="arrowRight" />
                    </IconWrapper>
                    <StandardTileName>{__('See all')}</StandardTileName>
                </StyledTileContent>
            </StyledTile>
        </AspectRatio>
    );
}
